/**
 * Design tokens for the catalog web app.
 *
 * Source of truth: ../../../../softfone-app/flutter-app/UI_GUIDELINES.md
 * The mobile guide uses pt; on web we treat 1pt ≈ 1px for sizing values.
 * Hex values match the guide verbatim — keep them in lockstep.
 */

export const colors = {
  bg: {
    canvas: "#F2F2F7",
    surface: "#FFFFFF",
    surfaceMuted: "#F4F4F6",
  },
  border: {
    hairline: "#E5E5EA",
  },
  text: {
    primary: "#0B0B0F",
    secondary: "#8E8E93",
    tertiary: "#C7C7CC",
    onAccent: "#FFFFFF",
  },
  brand: {
    purple: "#6B4EFF",
    purpleTint: "#E8E3FA",
  },
  action: {
    blue: "#3A4CE5",
    blueTint: "#E8EBFB",
    blueHover: "#3140C9",
  },
  status: {
    success: "#34C759",
    danger: "#FF3B30",
    warning: "#FF9F0A",
    offline: "#8E8E93",
  },
};

export const radii = {
  card: 16,
  button: 14,
  input: 12,
  chip: 999,
};

/**
 * Flutter's 4pt grid tokens, in px. The MUI `spacing` multiplier stays at 8
 * (default) so existing `sx={{ p: 2 }}` literals across the app keep their
 * current 16px value — non-destructive. Use these named tokens when you need
 * to express the *intent* (e.g. "this is space/6 between card groups").
 */
export const space = {
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
};

export const typography = {
  fontFamily:
    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  weight: {
    regular: 400,
    medium: 500,
    semibold: 600,
  },
};

export const motion = {
  fast: 80,
  short: 150,
  medium: 200,
  modal: 250,
};

/**
 * Single soft shadow reserved for floating surfaces (popovers, menus). The
 * guide says cards are flat — do not reuse this for cards or rows.
 */
export const elevation = {
  none: "none",
  floating: "0 8px 24px rgba(11,11,15,0.08), 0 1px 2px rgba(11,11,15,0.04)",
};
